module.exports = __webpack_public_path__ + "static/greg-white-0ddd630362e1f2395dfe6ccec388f735.png";